import { useEffect, useState } from "react";
import { postAxios } from "../../util/apiCall";
import moment from "moment";

export const useDashboard = () => {
  const dataAuth = localStorage.getItem("auth");
  const dataUser = JSON.parse(dataAuth);

  const [listBpb, setListBpb] = useState([]);
  const [filterTahun, setFilterTahun] = useState(
    moment().utcOffset("+0700").year()
  );

  useEffect(() => {
    postAxios(
      `${process.env.REACT_APP_ENDPOINT}/getMonitorBpb`,
      {
        tim: dataUser.tim,
        filterTahun: filterTahun,
      },
      dataUser.auth,
      setListBpb,
      ""
    );
  }, [filterTahun]);

  return { filterTahun, setFilterTahun, listBpb };
};
